import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; 

const firebaseConfig = {
  apiKey: "AIzaSyCsiDJhQRmLMQG4xDlo-i28VF_oNwe_jcg",
  authDomain: "neods-c3270.firebaseapp.com",
  databaseURL: "https://neods-c3270.firebaseio.com",
  projectId: "neods-c3270",
  storageBucket: "neods-c3270.appspot.com",
  messagingSenderId: "296596321637",
  appId: "1:296596321637:web:69bca795b4712a50c35d8c",
  measurementId: "G-X240LQL8FX"
};

// ✅ Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// ✅ Initialize Realtime Database
const db = getDatabase(firebaseApp);

// ✅ Initialize Firebase Storage
const storage = getStorage(firebaseApp);

// ✅ Initialize Firebase Authentication
const auth = getAuth(firebaseApp);

export { firebaseApp, db, storage, auth }; // ✅ Export auth
